import * as React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import styled from 'styled-components';

import { VirtualTourJsonType } from '@bb/domain/dist/types';
import { isValidEmail } from 'utils';

interface VtGuestsFormProps {
  updateState: (draft: Record<string, any>) => void;
  selectedTour?: VirtualTourJsonType;
}

const VtGuestsForm: React.FC<VtGuestsFormProps> = ({
  updateState,
  selectedTour,
}) => {
  const [initialValues, setInitialValues] = React.useState({
    g0Name: '',
    g0Email: '',
    g1Name: '',
    g1Email: '',
    g2Name: '',
    g2Email: '',
  });
  // when selected tour changes, update state's invitees
  React.useEffect(() => {
    const existingGuests = selectedTour?.invitees;
    if (existingGuests) {
      setInitialValues({
        g0Name: existingGuests[0]?.name || '',
        g0Email: existingGuests[0]?.email || '',
        g1Name: existingGuests[1]?.name || '',
        g1Email: existingGuests[1]?.email || '',
        g2Name: existingGuests[2]?.name || '',
        g2Email: existingGuests[2]?.email || '',
      });
      updateState((draft: any) => {
        draft.invitees = existingGuests;
        draft.selectedTour = {
          ...draft.selectedTour,
          invitees: existingGuests,
        };
      });
    } else {
      setInitialValues({
        g0Name: '',
        g0Email: '',
        g1Name: '',
        g1Email: '',
        g2Name: '',
        g2Email: '',
      });
    }
  }, [selectedTour?.id]);

  const invitees = [0, 1, 2];
  // Formik

  const validate = (values: any) => {
    const errors: any = {};
    const inviteesArray: { name?: string; email?: string }[] = [];
    invitees.forEach(guestNum => {
      const guestEmailIndex = `g${guestNum}Email`;
      const guestEmail = values[guestEmailIndex];
      const guestName = values[`g${guestNum}Name`];
      if (!guestEmail || isValidEmail(guestEmail)) {
        inviteesArray.push({
          name: guestName,
          email: guestEmail,
        });
      } else {
        errors[guestEmailIndex] = 'Invalid email address';
      }
    });

    updateState((draft: any) => {
      draft.invitees = inviteesArray;
      draft.selectedTour = { ...draft.selectedTour, invitees: inviteesArray };
    });
    return errors;
  };

  return (
    <Formik
      initialValues={initialValues}
      validate={values => validate(values)}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(false);
      }}
      enableReinitialize
    >
      {() => (
        <Form style={{ width: '100%' }}>
          <StyledTable>
            {invitees.map(inviteeNum => (
              <StyledTbody key={`g${inviteeNum}`}>
                <StyledTr>
                  <td>
                    <i className="fa fa-user fa-lg" />
                  </td>
                  <td>
                    <Field
                      placeholder="Client Name"
                      autoComplete="off"
                      className="form-control"
                      name={`g${inviteeNum}Name`}
                      type="text"
                      data-cy="invite-guests-name"
                    />
                    <ErrorMessage
                      className="error"
                      component="label"
                      name={`g${inviteeNum}Name`}
                    />
                  </td>
                </StyledTr>

                <StyledTr>
                  <td>
                    <i className="fa fa-envelope fa-lg" />
                  </td>
                  <td>
                    <Field
                      placeholder="Email"
                      autoComplete="off"
                      className="form-control"
                      name={`g${inviteeNum}Email`}
                      type="email"
                      data-cy="invite-guests-email"
                    />

                    <ErrorMessage
                      className="error"
                      component="label"
                      name={`g${inviteeNum}Email`}
                    />
                  </td>
                </StyledTr>
              </StyledTbody>
            ))}
          </StyledTable>
        </Form>
      )}
    </Formik>
  );
};

export default VtGuestsForm;

const StyledTable = styled.table`
  border-collapse: collapse;
  width: 100%;
`;

const StyledTr = styled.tr`
  td {
    text-align: center;
    padding: 5px;
  }
`;

const StyledTbody = styled.tbody`
  border-top: 15px solid transparent;
`;
